import React from 'react';
import { Spotlight } from './Spotlight';
import { Star, Quote } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    text: 'No hay nada igual en Queens. Stefania realmente diagnostica tu cabello antes de hacer cualquier cosa. Salí con el cabello más hermoso de mi vida.',
    author: 'Clienta Verificada'
  }, {
    text: 'Llevaba años con miedo a los alisados por el daño. Aquí me explicaron todo, usaron productos naturales y mi cabello quedó increíble. ¡Y sin olor a químicos!',
    author: 'Clienta Verificada'
  }, {
    text: 'Llevo 4 meses desde mi última sesión y mi cabello sigue perfecto. Valió cada centavo.',
    author: 'Clienta Verificada'
  }];
  return <section id="testimonios" className="py-20 bg-beige-50 relative overflow-hidden" data-id="element-470">
      <Spotlight className="opacity-40" data-id="element-471" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-472">
        <div className="text-center mb-16" data-id="element-473">
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-900 mb-4" data-id="element-474">
            Por qué mujeres en Queens{' '}
            <span className="metallic-gold-text italic" data-id="element-475">nos eligen</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-476">
          {testimonials.map((item, index) => <div key={index} className="bg-white p-8 rounded-3xl shadow-sm border border-beige-100 relative" data-id="element-477">
              <Quote className="absolute top-6 right-6 w-10 h-10 opacity-30 rotate-180 fill-current" style={{
            color: '#C9B58A'
          }} data-id="element-478" />
              <div className="flex space-x-1 mb-6" data-id="element-479">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-current" style={{
              color: '#C9B58A',
              filter: 'drop-shadow(0 1px 2px rgba(120, 90, 40, 0.35)) drop-shadow(0 0 6px rgba(220, 200, 160, 0.5))'
            }} data-id="element-480" />)}
              </div>
              <p className="text-neutral-700 italic mb-6 relative z-10" data-id="element-481">
                "{item.text}"
              </p>
              <div className="flex items-center space-x-3" data-id="element-482">
                <div className="w-10 h-10 bg-beige-200 rounded-full flex items-center justify-center text-gold-600 font-serif font-bold" data-id="element-483">
                  {item.author.charAt(0)}
                </div>
                <span className="font-medium text-neutral-900 text-sm" data-id="element-484">
                  {item.author}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};